export default function getResource(label, vars = []) {
    const resources = {
        autoReplenish: 'Réapprovisionnement automatique',
        nextShipment: 'Prochaine livraison le',
        pausedDelivery: 'Livraison en pause chaque',
        manageSubscription: 'Gérer l’abonnement',
        resumeSubscription: 'Reprendre l’abonnement',
        unsubscribe: 'Se désabonner',
        save: 'économisez',
        annuallyWithSubscription: 'chaque année avec cet abonnement.',
        deliverEvery: 'Livraison chaque',
        paused: 'En pause',
        canceled: 'Annulée',
        viewMore: 'En voir plus',
        viewMoreSubscriptions: 'View More Subscriptions',
        item: `ARTICLE ${vars[0]}`,
        needHelp: 'Besoin d’aide?',
        viewFAQ: 'Voir la FAQ',
        rateOf: `à un taux de ${vars[0]} % de réduction`,
        stillSave: 'vous pouvez quand même économiser',
        before: 'avant',
        autoReplenishPromoInfoModalMsg2: 'Après trois livraisons ou après expiration, selon la première éventualité, votre abonnement se renouvelle à un taux de réduction de 5 %.*',
        autoReplenishPromoInfoModalButton: 'Compris',
        lastDeliveryLeft: `livraison restante à ${vars[0]} % de réduction`,
        deliveriesLeft: `livraisons restantes à ${vars[0]} % de réduction`,
        discountValidUntil: `Réduction en vigueur jusqu’au ${vars[0]}`,
        discountsValidUntil: `Réductions en vigueur jusqu’au ${vars[0]}`,
        or: 'Ou',
        savePercentage: `économisez ${vars[0]} %`,
        getItBefore: 'si vous le vous procurez avant le',
        canceledSubscriptionsHeading: 'Canceled Subscriptions',
        canceledSubscriptionsSubheading: 'Visit product details to create a new active subscription',
        headerItem: 'Item',
        headerPrice: 'Price',
        viewProductDetails: 'View Product Details',
        cancelledOn: `Canceled on ${vars[0]}`,
        discountRate: `${vars[0]}% Off`,
        activeSubscriptionsCount: `1-${vars[0]} of ${vars[1]} Active Subscriptions`,
        pausedSubscriptionsCount: `1-${vars[0]} of ${vars[1]} Paused Subscriptions`,
        canceledSubscriptionsCount: `1-${vars[0]} of ${vars[1]} Canceled Subscriptions`
    };

    return resources[label];
}
